import React, { useContext, useRef, useState, useMemo } from 'react'
import { WagmiConfig, createConfig, configureChains } from 'wagmi'
import ModalETHWallets from 'wallet-module/components/ModalETHWallets'
import { CoinbaseWalletConnector } from 'wagmi/connectors/coinbaseWallet'
import { MetaMaskConnector } from 'wagmi/connectors/metaMask'
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect'
import { publicProvider } from 'wagmi/providers/public'
import { infuraProvider } from 'wagmi/providers/infura'
import * as allChains from 'wagmi/chains'
interface IWalletProvider {
  showETHConnectionModal: boolean
  setShowETHConnectionModal: (isVisible: boolean) => void
  supportedChainID: number
  setIsDisconnecting: (isConnecting: boolean) => void
  isDisconnecting: boolean
}
const WalletContext = React.createContext<IWalletProvider>({
  showETHConnectionModal: false,
  setShowETHConnectionModal: () => {},
  supportedChainID: 1,
  setIsDisconnecting: (isConnecting: boolean) => {},
  isDisconnecting: false
})

interface WalletProviderProps {
  children: JSX.Element
  supportedChainID: number
  infuraKey: string
  walletConnectProjectID: string
}
const WalletProvider = ({
  children,
  supportedChainID,
  infuraKey,
  walletConnectProjectID
}: WalletProviderProps): JSX.Element => {
  const [showETHConnectionModal, setShowETHConnectionModal] = useState<boolean>(false)
  const [isDisconnecting, setIsDisconnecting] = useState<boolean>(false)
  const walletWagmiConfig = useMemo(() => {
    const chainsList = allChains as any

    let supportedChain = allChains.mainnet
    for (const chainKey in chainsList) {
      if (chainsList[chainKey].id == supportedChainID) {
        supportedChain = chainsList[chainKey]
        break
      }
    }
    const { chains, publicClient, webSocketPublicClient } = configureChains(
      [supportedChain],
      [infuraProvider({ apiKey: infuraKey ?? '' }), publicProvider()]
    )
    const walletWagmiConfig = createConfig({
      autoConnect: true,
      connectors: [
        new MetaMaskConnector({
          options: {
            shimDisconnect: true,
            UNSTABLE_shimOnConnectSelectAccount: true
          },
          chains
        }),
        new WalletConnectConnector({
          options: {
            projectId: walletConnectProjectID,
            qrModalOptions: {
              themeVariables: { '--wcm-z-index': '10000' }
            }
          },
          chains
        }),
        new CoinbaseWalletConnector({
          options: {
            appName: 'wagmi'
          },
          chains
        })
      ],
      publicClient,
      webSocketPublicClient
    })
    return walletWagmiConfig
  }, [infuraKey, supportedChainID, walletConnectProjectID])

  return (
    <WagmiConfig config={walletWagmiConfig}>
      <WalletContext.Provider
        value={{
          showETHConnectionModal,
          setShowETHConnectionModal,
          supportedChainID,
          isDisconnecting,
          setIsDisconnecting
        }}>
        <>
          {children}
          <ModalETHWallets />
        </>
      </WalletContext.Provider>
    </WagmiConfig>
  )
}
export default WalletProvider

export const useWalletProviderContext = (): IWalletProvider => useContext(WalletContext)
